<template>
  <div v-if="token" class="token-card">
    <div class="token-card__header">
      <div class="token-card__info">
        <span class="token-card__label">Amount raised</span>
        <div class="token-card__amount">
          <span class="token-card__value">
            {{ token?.total_raised ? formatAmountToDollar(token?.total_raised * 10, 2, "USD") : formatAmountToDollar(0, 2, "USD") }}
          </span>
          <span class="token-card__percentage">
            {{ totalRaised ? totalRaised?.toFixed(2) : 0 }}%
          </span>
        </div>
      </div>
    </div>

    <div class="progress-section">
      <div class="progress-bar">
        <div class="progress-bar__fill" ref="fill"></div>
      </div>
      <div class="progress-info">
        <span class="progress-info__text">
          {{ formatAmountToDollar(token?.total_raised * 10, 2, "USD") || formatAmountToDollar(0, 2, "USD") }}
          <span class="progress-info__muted">out of</span>
          {{ formatAmountToDollar(token?.raise_amount, 2, "USD") || formatAmountToDollar(0, 2, "USD") }}
          <span class="progress-info__muted">raised</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { formatAmountToDollar } from "@/utils/helpers.js";
import Btn from "@/components/general/BtnComponent.vue";

export default {
  name: "TokenCard",

  components: { Btn },

  props: {
    token: { type: Object, default: () => {}, required: true },
  },

  data() {
    return {
      totalRaised: 0,
    };
  },

  mounted() {
    this.calculateRaise();
  },

  methods: {
    formatAmountToDollar,

    calculateRaise() {
      this.totalRaised =
        ((this.token?.total_raised * 10) / this.token?.raise_amount) * 100;
      this.$refs.fill.style.transform = `translateX(${this.totalRaised - 100}%)`;
    },
  },

  watch: {
    token(newValue, oldValue) {
      deep: true;
      immediate: true;
      if (newValue !== oldValue) {
        this.calculateRaise();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.token-card {
  background: white;
  border: 1px solid #E2E8F0;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.04);

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 24px;
  }

  &__info {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  &__label {
    font-family: 'DM Sans', sans-serif;
    font-size: 13px;
    font-weight: 400;
    color: #64748B;
  }

  &__amount {
    display: flex;
    align-items: baseline;
    gap: 10px;
  }

  &__value {
    font-family: 'DM Sans', sans-serif;
    font-size: 28px;
    font-weight: 500;
    color: #0F172A;
  }

  &__percentage {
    display: inline-flex;
    align-items: center;
    padding: 4px 10px;
    background: #ECFDF5;
    border-radius: 20px;
    font-family: 'DM Sans', sans-serif;
    font-size: 13px;
    font-weight: 500;
    color: #10B981;
  }
}

.progress-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.progress-bar {
  position: relative;
  height: 10px;
  background: #E2E8F0;
  border-radius: 5px;
  overflow: hidden;

  &__fill {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: linear-gradient(90deg, #10B981 0%, #34D399 100%);
    border-radius: 5px;
    transition: transform 0.5s ease;
    transform: translateX(-100%);
  }
}

.progress-info {
  display: flex;
  justify-content: space-between;
  align-items: center;

  &__text {
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: #0F172A;
  }

  &__muted {
    font-weight: 400;
    color: #64748B;
  }
}
</style>
